<template>
  <div>
      <Nav></Nav>
      <div class="industry">
  <div class="w">
    <!-- <div class="indetrbar"></div> -->
    <div class="indust">
      <!-- <a href="javascript:;" ref="standend">行业资讯</a> -->
      <img src="../assets/img/zixun.png" ref="standend" alt="">
    </div>
    <ul>
      <li v-for="(item,index) in peloobj" :key="index" v-show="item.news_id===42">
        <div class="industr-left" @click="accumulations(peloobj[0].news_id)">
          <img  v-lazy="peloobj[0].news_img" alt="">
         <h2>{{peloobj[0].news_name}}</h2>
         <p>{{peloobj[0].author + '...'}}</p>
         <div class="time">
          <div class="shotime">
             <div class="time-icon">
             <img src="../assets/image/timeg.png" alt="">
           </div>
           <div class="times">{{peloobj[0].add_time}}</div>
           <!-- <div class="timesfut">09:42</div> -->
            <div class="mabr">
              <img src="../assets/image/look.png" alt="">
            </div>
            <div class="ckick">
             {{peloobj[0].show_num}}
            </div>
          </div>

         </div>
        </div>
        <div class="industr-right">
          <ol>

             <li v-for="(item,index) in peloobj" :key="index">
              <div class="inder-masetr">
                <div class="border">
                 <p> {{item.add_time}}</p>
                </div>
                <div class="madebar" @click="$router.push({path:`/new/${item.news_id}`,query:{newst:JSON.stringify(item)}})">
                    <p>{{item.news_name}}</p>
                    <span>{{item.author+'...'}}</span>
                </div>
              </div>
            </li>
            <button @click="more">查看更多 </button>
          </ol>
        </div>
      </li>
    </ul>
  </div>
</div>
<Footer></Footer>
  </div>
</template>

<script>
import { Peoplenews, accumulation } from '../api/index'
import Footer from '../components/Footer'
import Nav from '../components/Nav'
export default {
  components: {
    Footer,
    Nav
  },
  data () {
    return {
      peloobj: []
    }
  },
  mounted () {
    this.peolnew()
  },
  methods: {
    async  accumulations (va) {
      // const shonum = sessionStorage.getItem('shownum')
      // console.log(shonum)
      this.$router.push({ path: `/new/${va}`, query: { newst: JSON.stringify(this.peloobj[0]) } })
      const res = await accumulation({

      }, {
        news_id: va
      })
      console.log(res)
      const { data } = res
      if (data.code === 0) {
        this.shownum = data.show_num
      }
    },
    async peolnew () {
      const res = await Peoplenews({

      }, {
        c_id: 1
      })

      const { data } = res
      if (data.code === 0) {
        console.log(data)
        this.peloobj = data.data

        this.peloobj = this.peloobj.splice(0, 4)
        console.log(this.peloobj)
      }
    },
    more () {
      this.$router.push({ path: '/more' })
    }
  }
}
</script>

<style lang="scss" scoped>
.industry {
     margin-top: 135px;
     position: relative;
     .indetrbar {
       position: absolute;
       top: 102px;
       width: 1200px;
       border-bottom: 1px solid #EBECED;
     }
     .w {
       .indust {
        height: 29px;
        font-size: 29px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        cursor: pointer;
        line-height: 90px;
        text-align: center;
        margin-bottom: 160px;
        margin-top: 60px;
        a {
           color: #3F3F40;
           &:hover {
              border-bottom: 4px solid#046AFF;
           }
        }
       }
      ul {
        li {
          display: flex;
          .industr-left {
            cursor: pointer;
            margin-right: 50px;
            img {
              width: 540px;
              height: 372px;
            }
            h2 {
            height: 22px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #1777FE;
            line-height: 20px;
            margin-top: 33px;

            margin-bottom: 24px;
            }
            p {
              width: 529px;
              height: 68px;
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              line-height: 28px;
              margin-bottom: 20px;
            }
            .time {
              .shotime {
                display: flex;
                 .time-icon {
                img {
                  width: 21px;
                  height: 21px;
                }

                  }

                    .times {
                  margin-left: 13px;
                }
                .timesfut {
                  margin-left: 13px;
                }
                .mabr {
                  margin-left: 50px;
                  img {
                    width: 28px;
                    height: 18px;
                  }
                }
                .ckick {
                  margin-left: 12px;
                }
              }

            }
          }
           .industr-right {
                   display: flex;

             ol {
               li {
                 margin-bottom: 31px;

                    &:nth-child(1) .inder-masetr .border{
                   width: 167px;
                   margin-top: 2px;
                   }
                    &:nth-child(2) .inder-masetr .border{
                  width: 167px;
                     margin-top: 2px;
                   }
                    &:nth-child(1) .inder-masetr a{

                   font-weight: 700;
                   }
                    &:nth-child(1) .inder-masetr a{
                  margin-left: 20px !important;
                   font-weight: 700;
                   }
                  &:nth-child(2) .inder-masetr a{
                  margin-left: 57px !important;
                   font-weight: 700;
                   }
                     &:nth-child(3) .inder-masetr a{
                     margin-left: 30px !important;
                      font-weight: 700;
                   }
                      &:nth-child(4) .inder-masetr a{
                     margin-left: 55px !important;
                     font-weight: 700;
                   }
                    &:nth-child(3) .inder-masetr .border{
                   width: 167px;
                      margin-top: 2px;
                   }
                    &:nth-child(4) .inder-masetr .border{
                   width: 145px;
                      margin-top: 2px;
                   }
                 .inder-masetr{
                   display: flex;

                   .border {
                     width: 100px;
                     height: 28px;
                    background: #CCCCCC;
                    border-radius: 4px;
                     margin-right: 40px;
                     text-align: center;
                     line-height: 28px;
                     p {

                      height: 14px;
                      font-size: 16px;
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      color: #FFFFFF;
                      line-height: 28px;
                     }
                   }

                   .madebar {
                     cursor: pointer;
                     p {
                      //  width: 360px;
                       margin-bottom: 16px;
                      //  height: 21px;
                       font-size: 20px;
                       font-family: Microsoft YaHei;
                       font-weight: 400;
                       color: #404040;
                      //  line-height: 23px;

                     }
                     span {
                      font-size: 16px;
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      color: #999999;
                      line-height: 25px;
                      letter-spacing: 1px;
                     }
                      a {
                        color: #357FEC;
                      }
                   }
                 }
               }
               button {
                 width: 144px;
                 height: 51px;
                 border: 1px solid #0696FE;
                 border-radius: 4px;
                 background-color: #fff;
                 color:#0696FE ;
                 cursor: pointer;
                 margin-left: 480px;
               }
             }
          }
        }
      }
     }
   }
</style>
